import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { Box, Button, HStack, Input } from "@chakra-ui/react";
import { useEffect } from "react";
import { Controller, useFieldArray, useWatch } from "react-hook-form";

export const DynamicKeyValueInput = ({
  control,
  name,
  placeholderKey,
  placeholderValue,
}) => {
  const { fields, append, replace, remove } = useFieldArray({ control, name });

  // Watch current field value (object or array)
  const currentValue = useWatch({ control, name });

  // Convert object → array once (only on mount or when value changes)
  useEffect(() => {
    if (currentValue && !Array.isArray(currentValue)) {
      const arr = Object.entries(currentValue).map(([key, value]) => ({
        key,
        value,
      }));
      replace(arr);
    }
  }, [currentValue, replace]);

  return (
    <Box>
      {fields.map((item, index) => (
        <HStack key={item.id} mb={2}>
          <Controller
            control={control}
            name={`${name}.${index}.key`}
            render={({ field }) => (
              <Input
                {...field}
                placeholder={placeholderKey}
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
              />
            )}
          />
          <Controller
            control={control}
            name={`${name}.${index}.value`}
            render={({ field }) => (
              <Input
                {...field}
                placeholder={placeholderValue}
                borderRadius="md"
                borderColor="gray.300"
                bg="white"
              />
            )}
          />
          <Button
            size="sm"
            colorScheme="red"
            variant="ghost"
            onClick={() => remove(index)}
          >
            <DeleteIcon />
          </Button>
        </HStack>
      ))}

      <Button
        size="sm"
        leftIcon={<AddIcon />}
        onClick={() => append({ key: "", value: "" })}
      >
        Add Field
      </Button>
    </Box>
  );
};
